import { createEffectFn } from '@ngneat/effects';
import { catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap } from 'rxjs';
import { historyService } from './history.service';
import { HistoriesState } from './history.store';

type SearchHistoriesParams = Partial<HistoriesState>

export const searchHistoriesEffect = createEffectFn((params$: Observable<SearchHistoriesParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => historyService.getHistories().pipe(catchError(() => EMPTY)))
  );
});
